var _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFolderFrontBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 162,
    viewBox: "0 0 196 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5098 0.255859L12.5137 0.507812L12.7646 16.0938C12.9063 24.877 20.0672 31.9229 28.8516 31.9229H166.427C175.28 31.9229 182.471 24.7695 182.516 15.916L182.594 0.510742L182.596 0.255859H194.853V153.227C194.853 157.881 191.079 161.654 186.425 161.654H8.68262C4.02836 161.654 0.254883 157.881 0.254883 153.227V0.255859H12.5098Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5098 0.255859L12.5137 0.507812L12.7646 16.0938C12.9063 24.877 20.0672 31.9229 28.8516 31.9229H166.427C175.28 31.9229 182.471 24.7695 182.516 15.916L182.594 0.510742L182.596 0.255859H194.853V153.227C194.853 157.881 191.079 161.654 186.425 161.654H8.68262C4.02836 161.654 0.254883 157.881 0.254883 153.227V0.255859H12.5098Z",
    fill: "url(#paint0_linear_2518_3203)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5098 0.255859L12.5137 0.507812L12.7646 16.0938C12.9063 24.877 20.0672 31.9229 28.8516 31.9229H166.427C175.28 31.9229 182.471 24.7695 182.516 15.916L182.594 0.510742L182.596 0.255859H194.853V153.227C194.853 157.881 191.079 161.654 186.425 161.654H8.68262C4.02836 161.654 0.254883 157.881 0.254883 153.227V0.255859H12.5098Z",
    fill: "url(#paint1_linear_2518_3203)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5098 0.255859L12.5137 0.507812L12.7646 16.0938C12.9063 24.877 20.0672 31.9229 28.8516 31.9229H166.427C175.28 31.9229 182.471 24.7695 182.516 15.916L182.594 0.510742L182.596 0.255859H194.853V153.227C194.853 157.881 191.079 161.654 186.425 161.654H8.68262C4.02836 161.654 0.254883 157.881 0.254883 153.227V0.255859H12.5098Z",
    stroke: "#06306B",
    strokeWidth: 0.510753
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2518_3203",
    x1: 80.2315,
    y1: -92.209,
    x2: 80.2315,
    y2: 68.6781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.608402,
    stopColor: "#EDF5FF",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDF5FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2518_3203",
    x1: 148.208,
    y1: -79.7733,
    x2: -11.4067,
    y2: -56.4035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1B78FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#07377C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderFrontBlue);
export default __webpack_public_path__ + "static/media/folder-front-blue.d48dfd15377b4bbcfcc3273625a48a14.svg";
export { ForwardRef as ReactComponent };